import PropTypes from 'prop-types'
import classNames from 'classnames'
import moment from 'moment'
import { useTranslation } from 'react-i18next'

import Tooltip from '../common/Tooltip'
import { accoladeBadges } from '../../utility/coaches'
import { stockAccolades } from '../../accolades/accolades'

import classes from './AccoladeBadges.module.scss'

const AccoladeBadges = ({ userAccolades }) => {
  const { t } = useTranslation()

  const tooltipText = (badge) => (
    badge.earned.length === 0
      ? t('portal.badges.notEarned')
      : badge.earned.map(userAccolade => [
        userAccolade.accolade.name,
        userAccolade.issued_date && t('portal.badges.issuedOn', { date: moment(userAccolade.issued_date).format('MMM D, YYYY') }),
      ].filter(Boolean).join(' · ')).join('<br />')
  )

  return (
    <div className={classNames('d-flex justify-content-center flex-wrap', classes.badges)}>
      {accoladeBadges(userAccolades).map(badge => (
        <div
          key={badge.key}
          className={classNames('d-flex flex-column align-items-center', classes.badge, { [classes.unearned]: badge.earned.length === 0 })}
          data-for='accoladeBadges'
          data-tip={tooltipText(badge)}
        >
          <img src={stockAccolades[badge.accoladeName].badge} alt='' className={classes.badgeImage} />
          <span>{t(`portal.badges.${badge.key}`)}</span>
        </div>
      ))}
      <Tooltip id='accoladeBadges' place='bottom' multiline />
    </div>
  )
}

AccoladeBadges.propTypes = {
  userAccolades: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    issued_date: PropTypes.string,
    accolade: PropTypes.shape({ name: PropTypes.string }),
  })),
}

export default AccoladeBadges
